import { DialogType, DialogVariant } from '@/enums/ui.enum';

import { useOruga } from '@oruga-ui/oruga-next';

import UiDialog from '@/components/Global/UiDialog/UiDialog.vue';
import { toast as sonner } from 'vue-sonner';

const isLoading = ref<boolean>(false);

type DialogProps = {
    type?: `${DialogType}`;
    title?: string;
    message?: string;
    variant?: `${DialogVariant}`;
    onClose?: () => void;
    onCancel?: () => void;
    onConfirm?: (value?: string) => Promise<void> | void;
    trapFocus?: boolean;
    cancelText?: string;
    inputProps?: object;
    confirmText?: string;
    hasModalCard?: boolean;
};

const loader = {
    show: () => (isLoading.value = true),
    hide: () => (isLoading.value = false),
    isVisible: isLoading.value,
};

export default function usePopup() {
    const oruga = useOruga();

    /**
     * @deprecated Use "useDialogs()" from "@/shared/ui/Dialog" instead.
     */
    const dialog = (props: DialogProps) => {
        console.warn('usePopup().dialog() is deprecatred. Use "useDialogsStore()" instead.');

        props = {
            // Default props
            ...{
                type: 'confirm',
                title: '',
                message: '',
                variant: 'primary',
                trapFocus: true,
                cancelText: '',
                confirmText: '',
                hasModalCard: true,
                inputProps: {},
            },

            // User submitted props
            ...props,
        };

        const modal = oruga.modal.open({
            component: UiDialog,
            trapFocus: props.trapFocus,
            props: {
                type: props.type,
                title: props.title,
                variant: props.variant,
                message: props.message,
                inputProps: props.inputProps,
                cancelText: props.cancelText,
                confirmText: props.confirmText,
            },
            events: {
                close: () => {
                    if (props.onClose) {
                        props.onClose();
                    }

                    modal.close();
                },
                cancel: () => {
                    if (props.onCancel) {
                        props.onCancel();
                    }

                    modal.close();
                },
                confirm: async (value?: any) => {
                    if (props.onConfirm) {
                        await props.onConfirm(value);
                    }

                    modal.close();
                },
            },
        });
    };

    /**
     * @deprecated
     * Use `sonner` from `vue-sonner` directly
     */
    const toast = sonner;

    return {
        modal: oruga.modal,
        loader,
        dialog,
        toast,
    };
}
